import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import ProductSlider from './shop-components/product-slider-v1';
import Tamb2 from './completed-components/tamb02-info';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const Tamb02 = () => {
    return <div>
        <Navbar />
        {/* <PageHeader headertitle="Product Details" customclass="mb-0" /> */}
        {/* <ProductSlider /> */}
        <Tamb2 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Tamb02

